import React from 'react';
import additional from './personnel_grey.svg'

const Personnel_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Personnel_grey;
